<template>
	<div>
	  <el-submenu v-if="item.children" :index='item.id.toString()'>
	    <template slot="title">
		  <img src="https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/pintai.png" />
	      <span>{{item.name}}{{item.id}}</span>
	    </template>
	<!-- 	{{item.children}} -->
	      <SidebarItem v-for="(child,index) in item.children" :key='child.id' :item="child" ></SidebarItem>
	  </el-submenu>
	  <template v-else>
	  		  <el-menu-item  :index='item.id.toString()'>
	  		     <span>{{item.name}}{{item.id}}</span>
	  		  </el-menu-item>
	  </template>
	</div>
</template>

<script>
	export default{
		 name: 'SidebarItem',
		props: {
		  // route object
		  item: {
		    type: Object,
		    required: true
		  }
		},
		mounted() {
		},
		methods:{
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/silder/SidebarItem.vue